<template>
  <!-- book.is_expired:true、かつ、有効期限が最も後のsheetが期限切れの場合にグレーアウト -->
  <div
    v-if="isReadyToDraw"
    :class="{
      'expired-bookgroup':
        book.is_expired && countDownOfExpiredSheet === '00:00:00:00',
    }"
  >
    <!-- ブック -->
    <div class="list-item-book" @click="goToBook(bookGroup)">
      <!-- サムネイル -->
      <MbIndexThumbnailDisp :image-url="masterBook.content.ticket_image_url" />
      <!-- サムネイル -->

      <div class="index-content-center">
        <!-- チケット名 -->
        <MbIndexNameDisp :name="displayBookName(bookGroup, masterBook)" />
        <!-- チケット名 -->

        <!-- 有効期間 -->
        <BgMyticketAvailablePeriod
          v-if="book.user_started_at"
          :start="book.user_started_at"
          :limit="limitedAtMinusStartHour"
        />
        <!-- 日付選択なしで有効化前は、book.user_started_atがないのでbook.available_started_atを使用 -->
        <BgMyticketAvailablePeriod
          v-else
          :start="book.available_started_at"
          :limit="limitedAtMinusStartHour"
        />
        <!-- 有効期間 -->

        <!-- bookGroupに紐づいたラベル表示  -->
        <!-- 価格のないチケット(無料チケット)には存在しないので非表示 -->
        <div v-if="bookGroup.divisions_label" class="list-item__passenger">
          <span class="list-item__header">
            {{ $t("common.passengers") }}
          </span>
          <span class="list-item-value">
            {{ bookGroup.divisions_label }}
          </span>
        </div>
      </div>
    </div>
    <!-- ブック -->

    <!-- パス -->
    <div v-for="pass in book.passes" :key="pass.id">
      <ItemIndexPassTile
        :book-group="bookGroup"
        :pass="pass"
        :is-available-period="isAvailablePeriod"
        :is-expired-book="book.is_expired"
      />
    </div>
    <!-- パス -->

    <!-- シート -->
    <div v-for="sheet in book.sheets" :key="sheet.id">
      <ItemIndexSheetTile
        :book-group="bookGroup"
        :sheet="sheet"
        :my-coupon="getMyCoupon(sheet.id)"
        :is-available-period="isAvailablePeriod"
        :is-expired-book="book.is_expired"
        :is-used-status="isUsedStatus"
      />
    </div>
    <!-- シート -->

    <ItemIndexBookUsed v-if="isLocal" :book="book" />
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

import nativeHandlerService from "@/services/nativeHandler";
import myTicketsCommonService from "@/services/common/myTickets";

export default {
  name: "ItemIndexBookPassSheet",
  props: {
    bookGroup: {
      type: Object,
      required: true,
    },
    latestCountDownLimitOfBookGroup: {
      required: true,
      // type: Object or String(使用済みシートがない場合:String)
    },
    isUsedStatus: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();

    const isReadyToDraw = ref(false);
    const book = computed(() => props.bookGroup.books[0]);
    const masterBook = computed(() => props.bookGroup._master_book);
    const myCoupons = computed(() => store.getters["MFITT/myCoupons"]);

    const isAvailablePeriod = computed(() =>
      myTicketsCommonService.checkIsAvailablePeriod(
        book.value.available_started_at,
        book.value.available_limited_at
      )
    );
    const limitedAtMinusStartHour = computed(() => {
      // book.user_XXX_atがある場合
      if (book.value.user_started_at) {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          book.value.user_limited_at,
          masterBook.value.start_hour
        );
        // book.user_XXX_atがない場合
      } else {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          book.value.available_limited_at,
          masterBook.value.start_hour
        );
      }
    });

    const countDownOfExpiredSheet = ref(null);
    const countDownInterval = ref(null);

    const isLocal = process.env.NODE_ENV == "local" ? true : false;
    onMounted(() => {
      updateCountDownOfExpiredSheet();
      countDownInterval.value = setInterval(
        () => updateCountDownOfExpiredSheet(),
        1 * 1000
      );
    });

    watchEffect(() => {
      if (book.value != null && masterBook.value != null) {
        isReadyToDraw.value = true;
      }
      // countDownゼロの時点で、以降のステータスの変動はないのでintervalを止める
      if (countDownOfExpiredSheet.value == "00:00:00:00") {
        clearInterval(countDownInterval.value);
      }
    });

    // ↓↓↓↓リンク処理↓↓↓↓
    const goToBook = (selectedBookGroup) => {
      console.log("ENV :>> ", process.env.NODE_ENV);
      if (process.env.NODE_ENV == "local") {
        router.push({
          name: "Book",
          params: { book_group_id: selectedBookGroup.id },
          query: { language: store.getters["common/lang"] },
        });
      } else {
        nativeHandlerService.openTicket(
          `${process.env.VUE_APP_EMOT2_WEBVIEW_URL}my-tickets/ticketing/${selectedBookGroup.id}`
        );
      }
    };
    // ↑↑↑↑リンク処理↑↑↑↑

    // チケット全体をグレーアウトするか判別するため、有効期限が最も後のsheetのカウントダウンを計算する
    const updateCountDownOfExpiredSheet = () => {
      // 使用中のsheetがない場合は、countDownゼロでsheet使用済みとみなす
      if (props.latestCountDownLimitOfBookGroup === "NoSheetsInUse") {
        countDownOfExpiredSheet.value = "00:00:00:00";
      } else {
        countDownOfExpiredSheet.value = myTicketsCommonService.getCountDown(
          props.latestCountDownLimitOfBookGroup
        );
      }
    };

    const getMyCoupon = (id) => {
      // sheetのIDとmyCouponsのIDが一致するものを取得する。
      return myCoupons.value.find((e) => e.sheet_id === id);
    };

    return {
      book,
      masterBook,
      isReadyToDraw,
      goToBook,
      getMyCoupon,
      isAvailablePeriod,
      limitedAtMinusStartHour,
      countDownOfExpiredSheet,
      isLocal,
    };
  },
};
</script>

<style scoped lang="scss">
.index {
  position: relative;
}

.cb {
  clear: both;
}

.expired-bookgroup {
  background: #f0f0f0;
}

.list-item-book {
  height: 85px;
  max-height: 23vw;
}

.index-content-center {
  overflow: hidden;
  width: 73%;
  position: relative;
  height: 100%;
  padding-left: 2%;
  float: left;
}

.index-content-right {
  position: relative;
  top: 30%;
}

.list-item__passenger {
  font-size: 2vw;
  position: absolute;
  top: 80%;
  color: #777777;
  font-weight: bold;
  width: 100%;
}

.list-item__header {
  font-size: 3vw;
  width: 20%;
  display: inline-block;
}

.list-item-value {
  font-size: 3vw;
  font-weight: bold;
}

.white {
  background: white;
}

.button_is_not_in_period {
  color: #f76666;
  margin-top: -1px;
}

@media screen and (min-width: 421px) {
  /* ブラウザ対応 */
  .list-item-book {
    height: 20vw;
  }

  .list-item__passenger {
    top: 75%;
  }
}
</style>
